export default "__VITE_ASSET__2904f016__"